import { useEffect, useState } from "react";
import { getFullDocument } from "../services/getFullDocument";
import { useLocation } from "react-router-dom";

export function useFullDocument(
  documentId: string,
  query?: {
    include_questions?: boolean;
    include_knowledge_base?: boolean;
    include_slides?: boolean;
  }
) {
  const [fullDocument, setFullDocument] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const s = useLocation();

  const editScore = s.hash.split("#editScore=")?.[1] || "";

  async function asyncCall(showSpinner = true) {
    if (showSpinner) setLoading(true);
    if (!documentId) {
      setLoading(false);
      setFullDocument({});
      return;
    }
    const fullDocument = await getFullDocument(documentId, query);
    setFullDocument(fullDocument);
    setLoading(false);
  }

  useEffect(() => {
    asyncCall();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    documentId,
    query?.include_knowledge_base,
    query?.include_questions,
    query?.include_slides,
    editScore,
  ]);

  return { document: fullDocument, loading, refetch: asyncCall };
}
